import React, { useEffect, useState, useRef } from 'react';
import AOS from 'aos';
import 'aos/dist/aos.css';
import Lottie from 'lottie-react';
import arrowAnimation2 from '../../lottie/arrow-line-animation-dots.json';

const videoData = [ 
  {
    id: 1,
    title: 'Get Oriented',
    description: 'Overwhelmed by the hype around Gen AI and its disruptive impact? The first step is to recognize the immense future potential, but also learn the state of the art.\n\nBusiness leaders around the world are investing in projects that deliver immediate returns based on current technology. \n\n <b>Listen in</b>.',
    videoUrl: 'https://firebasestorage.googleapis.com/v0/b/aiar-25d06.appspot.com/o/informulate.ai%2FStepper%20One%20Final%20Cut.mp4?alt=media&token=9af62958-e3dc-4d5d-81d8-20c81fc4047c',
    poster: 'https://firebasestorage.googleapis.com/v0/b/aiar-25d06.appspot.com/o/informulate.ai%2Fvideo1thumb.png?alt=media&token=94460106-eba1-4dc3-a121-1ae55dd539fc',
    layout: 'content-right',
    arrowStyle: 'right-[10%]'
  },
  {
    id: 2,
    title: 'Start Planning',
    description: 'What uses cases for Gen AI exist within your organization/department? Identify the savings to be unlocked or the opportunities to be realized. \n\n Then calculate the return on investment to make a decision. \n\n <b>Play the video to learn how</b>.',
    videoUrl: 'https://firebasestorage.googleapis.com/v0/b/aiar-25d06.appspot.com/o/informulate.ai%2FStepper%20Two%20Final%20Cut.mp4?alt=media&token=2e8bfaee-b3f9-48e5-a327-729c5be9553d',
    poster: 'https://firebasestorage.googleapis.com/v0/b/aiar-25d06.appspot.com/o/informulate.ai%2Fvideo2thumb.png?alt=media&token=4948f6a4-7c4c-4fde-8601-be33cfb801d1',
    layout: 'content-left',
    arrowStyle: 'left-[10%]'
  },
  {
    id: 3,
    title: 'Execute and Enhance',
    description: 'Once you\'ve made a decision, you need to move quickly to minimize opportunity cost. Finding the right partner to not just deliver a solution but help with AI transformation methodology is crucial. \n\n Informulate is your long term partner that delivers with quality, extensibility and security.  \n\n <b>Click to learn more</b>.',
    videoUrl: 'https://firebasestorage.googleapis.com/v0/b/aiar-25d06.appspot.com/o/informulate.ai%2FStepper%20Three%20Final%20Cut.mp4?alt=media&token=d81ef9f5-e67b-4a16-b901-03e4ccde72f4',
    poster: 'https://firebasestorage.googleapis.com/v0/b/aiar-25d06.appspot.com/o/informulate.ai%2Fvideo3thumb.png?alt=media&token=3bb8e27d-8c62-468a-a312-17100a3e0ce5',
    layout: 'content-right',
    arrowStyle: ''
  }
];

const VideoCard = ({ data, isPlaying, onPlay, showArrow }) => {
  const { id, title, description, videoUrl, poster, layout, arrowStyle } = data;
  const videoRef = useRef(null);

  // Effect to play/pause video when isPlaying state changes
  useEffect(() => {
    const videoElement = document.getElementById(`video-${id}`);
    if (videoElement) {
      if (isPlaying === id) {
        // Play the video when this card's ID matches the playing ID
        videoElement.play().catch(error => {
          console.error("Error playing video:", error);
        });
      } else {
        // Pause the video when another video is playing
        videoElement.pause();
      }
    }
  }, [isPlaying, id]);

  const ContentSection = () => (
    <div className="w-1/2" data-aos="fade-up" data-aos-delay={id * 200}>
      <div className="flex items-center gap-4 mb-4">
        <div className="w-20 h-20 rounded-full bg-purple/10 flex items-center justify-center">
          <span className="text-purple font-semibold text-3xl">{id}</span>
        </div>
        <h3 className="text-3xl font-bold">{title}</h3>
      </div>
      <div className="text-gray-600 mb-4">
        {description.split('\n\n').map((paragraph, i) => {
          // Check if paragraph contains text to be bolded (marked with <b> tags)
          const parts = paragraph.split(/(<b>.*?<\/b>)/g);
          return (
            <p key={i} className="mb-2">
              {parts.map((part, j) => {
                if (part.startsWith('<b>') && part.endsWith('</b>')) {
                  // Extract text between <b> tags and make it bold
                  const boldText = part.replace(/<\/?b>/g, '');
                  return <span key={j} className="font-bold">{boldText}</span>;
                }
                return <span key={j}>{part}</span>;
              })}
            </p>
          );
        })}
      </div>
    </div>
  );

  const VideoSection = () => (
    <div className="w-1/2">
      <div className="relative aspect-video rounded-2xl overflow-hidden">
        <video
          id={`video-${id}`}
          ref={videoRef}
          className="w-full h-full object-cover"
          controls={isPlaying === id}
          poster={poster}
        >
          <source src={videoUrl} type="video/mp4" />
        </video>
        {isPlaying !== id && (
          <>
            <div className="absolute inset-0 bg-black/70" />
            <div
              className="absolute inset-0 flex items-center justify-center cursor-pointer"
              onClick={() => onPlay(id)}
            >
              <div className="video-one__play">
                <span className="fa-solid fa-play fa-fw">
                  <i className="ripple"></i>
                </span>
              </div>
            </div>
          </>
        )}
      </div>
    </div>
  );

  return (
    <div className="relative">
      {/* data-aos="fade-up" data-aos-delay={id * 200} */}
      <div className="p-8 py-16 bg-main-gray rounded-[10px] border border-[#e3e7fa]">
        <div className="flex items-center gap-8">
          {/* <div className="absolute -top-4 -left-4 w-8 h-8 bg-purple/10 rounded-full flex items-center justify-center">
            <i className="fa-solid fa-location-dot text-purple"></i>
          </div> */}
          {layout === 'content-right' ? (
            <>
              <VideoSection />
              <ContentSection />
            </>
          ) : (
            <>
              <ContentSection />
              <VideoSection />
            </>
          )}
        </div>
      </div>
      {showArrow && (
        <div
          className={`absolute ${id === 1 ? 'right-[45%]' : 'left-[45%]'} z-1000`}
          style={{
            top: '50%',
            transform: `translateY(60%) rotate(${id !== 1 ? '-45deg' : '45deg'})`
          }}
        >
          <i className="fa-solid fa-arrow-down text-purple/50" style={{ fontSize: '15rem', lineHeight: 1 }}></i>
        </div>
      )}
    </div>
  );
};

// Custom hook for intersection observer
const useIntersectionObserver = (options = {}) => {
  const [isVisible, setIsVisible] = useState(false);
  const ref = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(([entry]) => {
      setIsVisible(entry.isIntersecting);
    }, options);

    const currentRef = ref.current;
    if (currentRef) {
      observer.observe(currentRef);
    }

    return () => {
      if (currentRef) {
        observer.unobserve(currentRef);
      }
    };
  }, [options]);

  return [ref, isVisible];
};

const Arrow = ({ position, rotate, translateY }) => {
  const [ref, isVisible] = useIntersectionObserver({
    threshold: 0.2,
    triggerOnce: true,
    rootMargin: '-395px 0px'
  });
  const lottieRef = useRef();
  const [hasPlayed, setHasPlayed] = useState(false);

  useEffect(() => {
    if (isVisible && lottieRef.current && !hasPlayed) {
      // Reset and play animation when visible and hasn't played before
      lottieRef.current.goToAndPlay(0);
      setHasPlayed(true);
    }
  }, [isVisible, hasPlayed]);

  return (
    <div
      ref={ref}
      className={`absolute ${position} z-40 pointer-events-none`}
      style={{
        top: '50%',
        transform: `translateY(${translateY}) rotate(${rotate})`,
        width: '320px',
      }}
    >
      <Lottie
        lottieRef={lottieRef}
        animationData={arrowAnimation2}
        loop={false}
        autoplay={false}
        style={{ width: '100%', height: '100%' }}
      />
    </div>
  );
};

const TransformationStepsDesktop = () => {
  const [playingVideo, setPlayingVideo] = useState(null);

  useEffect(() => {
    AOS.init({ duration: 1000, once: true }); // Ensure animations run once
  }, []);

  return (
    <section className="py-20 pb-56 service-section-wrapper bg-white relative">
      <div className="theme-container mx-auto px-4">
        <div className="flex justify-center w-full title-area">
          <div className="flex flex-col items-center">
            <div className="py-0.5 px-5 bg-purple/5 border-purple/10 border rounded-[30px] font-medium text-purple mb-5">
              <span>We Meet You Where You Are</span>
            </div>
            <div className="mb-[60px]">
              <h2 className="text-main-black font-semibold text-24 sm:text-48 text-center max-w-[819px]">
                Get Oriented on AI Transformation
              </h2>
            </div>
          </div>
        </div>
        <div className="space-y-16 relative">
          {videoData.map((data, index) => (
            <React.Fragment key={data.id}>
              <VideoCard
                data={data}
                isPlaying={playingVideo}
                onPlay={setPlayingVideo}
              />
              {index < videoData.length - 1 && (
                <Arrow
                  position={index % 2 === 0 ? 'right-[37%]' : 'left-[35%]'}
                  rotate={index % 2 === 0 ? '-24deg' : '50deg'}
                  translateY={index % 2 === 0 ? '15%' : '-147%'}
                />
              )}
            </React.Fragment>
          ))}
        </div>
      </div>
    </section>
  );
};

export default TransformationStepsDesktop; 